<div class="card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>{{ 'Contracts Overview' | translate }}</h5>
    </div>
  </div>
  <div class="card-body pt-0">
    <span class="help-icon fas fa-info-circle"
        [ngbTooltip]="tooltip.text | translate"
        [placement]="tooltip.placement"
        container="body"></span>
    <ul class="user-list">
      <!-- Expired Contracts -->
      <a [routerLink]="['/hr/contracts/list']" 
         [queryParams]="{ status: 'expired' }"
          *ngIf="data">
        <li>
          <div class="user-icon danger">
            <div class="user-box"><i class="font-danger" data-feather="alert-circle"></i></div>
          </div>
          <div>
            <h5 class="mb-1">{{ data.expired }}</h5>
            <p>{{ 'Contracts Expired' | translate }}</p>
          </div>
        </li>
      </a>

      <!-- Contracts Due for Expiration -->
      <a [routerLink]="['/hr/contracts/list']" 
         [queryParams]="{ status: 'due_for_expiration' }"
          *ngIf="data">
        <li>
          <div class="user-icon warning">
            <div class="user-box"><i class="font-warning" data-feather="clock"></i></div>
          </div>
          <div>
            <h5 class="mb-1">{{ data.due_for_expiration }}</h5>
            <p>{{ 'Due for Expiration' | translate }}</p>
          </div>
        </li>
      </a>
    </ul>
  </div>
</div>
